import { Container, Row, Col } from 'react-bootstrap';

export default function CertificateCard(props: any) {
    return (
        <Container className='glass card mb-3'
        style={{
            minWidth: '200px',
        }}
        >
            <Row>
                <Col
                    xs='auto'
                    sm='auto'
                    md='auto'
                    lg='auto'
                    xl='auto'
                    xxl='auto'
                >
                    <img
                        src={props.Image}
                        alt='profile'
                        className='no-select cert-image card__image'
                    />
                </Col>
                <Container style={{background: `rgba(${props.ColorRGB}, 0.534)`}} className='glass card__description'>
                    <Col
                        xs='auto'
                        sm='auto'
                        md='auto'
                        lg='auto'
                        xl='auto'
                        xxl='auto'
                    >
                        <h4 className='text'>{props.Name}</h4>
                    </Col>
                    <Col
                        xs='auto'
                        sm='auto'
                        md='auto'
                        lg='auto'
                        xl='auto'
                        xxl='auto'
                    >
                        <h4 className='text'>{props.Title}</h4>
                    </Col>
                    <Col
                        xs='auto'
                        sm='auto'
                        md='auto'
                        lg='auto'
                        xl='auto'
                        xxl='auto'
                    >
                        <h5 className='text'>{props.Date}</h5>
                    </Col>
                </Container>
            </Row>
        </Container>
    );
}
